import {useState} from "react";
import SearchClientModal from "@manual_encounters/encounter_client_search/SearchClientModal";
import {useRosterStore} from "@/store/roster_store";
import CreateEditClientModal from "@manual_encounters/encounter_admit/pings/CreateEditClientModal";
import {EncounterClient} from "@/api/dto/encounter";

interface CreateAdmissionProps {
    hideModal: () => void,
}

export const REFERRAL_PATIENT = 'REFERRAL_PATIENT';
export const SEARCH_PATIENT = 'SEARCH_PATIENT';

const CreateReferrals = (props: CreateAdmissionProps) => {
  const {currentRoster} = useRosterStore();
  const [selectedPatient, setSelectedPatient] = useState<EncounterClient | undefined>(undefined);
  const [step, setStep] = useState(SEARCH_PATIENT);
  function handleHideChooseModal() {
    props.hideModal();
    setSelectedPatient(undefined);
    setStep(SEARCH_PATIENT);
  }

  function handleSelectPatient(patient: EncounterClient | undefined) {
    setSelectedPatient(patient);
    setStep(REFERRAL_PATIENT);
  }

  function renderModal() {
    switch (step) {
    case REFERRAL_PATIENT:
      return (
        <CreateEditClientModal
          type = {'referral'}
          hideModal={handleHideChooseModal}
          admittingGroup={currentRoster}
          patient={selectedPatient}
        />
      );
    case SEARCH_PATIENT:
    default:
      return (
        <SearchClientModal
          admittingGroup={currentRoster}
          type = {'referral'}
          hideModal={handleHideChooseModal}
          setSelectedPatient={handleSelectPatient}
        />);
    }
  }

  return renderModal();
};

export default CreateReferrals;
